import {
  AfterViewChecked,
  Component,
  ElementRef,
  Inject,
  OnDestroy,
  OnInit,
  PLATFORM_ID,
  ViewChild,
  ChangeDetectionStrategy
} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {CmsService} from '../../shared/services/cms.service';
import {SeoService} from '../../shared/services/seo.service';
import {isPlatformBrowser} from '@angular/common';
import {Subscription} from "rxjs";

@Component({
    selector: 'mbnm-shop-detail',
    providers: [CmsService],
    templateUrl: './shop-detail.component.html',
    styleUrls: ['./shop-detail.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ShopDetailComponent implements OnInit, OnDestroy, AfterViewChecked {

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private cms: CmsService,
    public seoService: SeoService,
    @Inject(PLATFORM_ID) private platformId: Object) {
  }

  collapsingDescriptionEnabled: boolean = false;
  descriptionCollapsed: boolean = true;
  products: any;
  productGroup: string;
  subRef: Subscription;

  @ViewChild('description') description: ElementRef;
  ngAfterViewChecked() {
    if (this.description && this.description.nativeElement.clientHeight > 300 && !this.collapsingDescriptionEnabled) {
      setTimeout( () => {
        this.collapsingDescriptionEnabled = true;
      });
    }
  }

  heroClicked() {
    this.descriptionCollapsed = !this.descriptionCollapsed;
  }

  ngOnInit() {
    this.subRef = this.route.params
      .subscribe(params => {
        this.productGroup = params['productGroup'];
        this.seoService.trackAdWordsRemarketingInfo('shop', this.productGroup);
        // set product to null in case its a subsequent route
        this.products = null;
        this.cms
          .merchData(this.productGroup)
          .then((productData) => {
            this.products = Array.isArray(productData) ? productData : [];
            if (this.products.length > 0) {
              this.seoService.setMetaData({
                title: this.products[0].pageTitle,
                description: this.products[0].metaDescription,
                og: this.products[0].image ? {
                  image: this.products[0].image.src
                } : null
              });
              this.products.forEach(product => {
                // TODO: remove this when we no longer have .html links in WP
                product.description = product.description.replace(/.html/g, '');
                if (product.builderButton.link) {
                  product.builderButton.link = product.builderButton.link.replace(/.html/g, '');
                }

                if (product.builderButton.link === 'NONE') {
                  product.builderButton.link = null;
                } else if (product.builderButton.link && product.builderButton.link[0] !== '/') {
                  product.builderButton.link = '/buy/' + product.builderButton.link;
                }
              });
            } else {
              this.router.navigateByUrl('/not-found',{ skipLocationChange: true });
            }

            // convert all relative links to internal routing (vs refresh the whole page)
            if (isPlatformBrowser(this.platformId)) {
              setTimeout(() => {
                const anchors = this.description && this.description.nativeElement.getElementsByTagName('a');
                if (anchors) {
                  for (let i = 0; i < anchors.length; i++) {
                    const anchor = anchors[i];
                    const href = anchor.attributes['href'] != null && anchor.attributes['href'].value ? anchor.attributes['href'].value : '';
                    if (href.startsWith('http') === false) {
                      anchor.addEventListener('click', (event) => {
                        event.preventDefault();
                        this.descriptionCollapsed = true;
                        this.router.navigateByUrl(href);
                      });
                    }
                  }
                }
              }, 0);
            }
          }, (err) => {
            this.router.navigateByUrl('/not-found',{ skipLocationChange: true });
          });
      });
  }

  ngOnDestroy() {
    if (this.subRef && !this.subRef.closed) {
      this.subRef.unsubscribe();
    }
  }
}
